import React from 'react';
import './Footer.css'
import { useForm, ValidationError } from '@formspree/react';
import { Container } from 'react-bootstrap';

const Footer = () => {
    const [state, handleSubmit] = useForm("mwkyegep");
  if (state.succeeded) {
      return <p>Thanks for joining!</p>;
  }
    return (
        <div id='contract' className='footer ' data-aos="fade-right"
        data-aos-anchor-placement="center-bottom"
        data-aos-duration="1000">
            <Container>
            <div className='row'>
            <div className='col-md-6'>
            <div className='contract'>
                 <dl>
               <dt>Phone:</dt>
               <dd>+8801854887095</dd>
               <dt>EMAIL</dt>
               <dd >armanh20439@gmail.com</dd>
               
             
               <dt>ADDRESS:</dt>
               <dd>CHANDPUR, BANGLADESH</dd>
               </dl>
                     </div>
            </div>
            <div className='col-md-6'>
            <form className='form' onSubmit={handleSubmit}>
      <label className='text-light' htmlFor="email">
        Email Address:
      </label><br/>
      <input
       className="form-control"
       placeholder='Your Email'
        id="email"
        type="email" 
        name="email"
      /> <br/>
      <ValidationError 
        prefix="Email" 
        field="email"
        errors={state.errors}
      />
       <label className='text-light' htmlFor="email">
        Message:
      </label><br/>
      <textarea
      placeholder='Text Messeage'
       className="form-control"
        id="message"
        name="message"
      /><br/>
      <ValidationError 
        prefix="Message" 
        field="message"
        errors={state.errors}
      />
      <button className='btn btn-danger mb-5' type="submit" disabled={state.submitting}>
        Submit
      </button>
    </form>
            </div>
            
            </div>

            </Container>
            
        </div>
    );
};

export default Footer;